import styled from 'styled-components';

import {Label} from '@edna/components/FormField';
import {mixins} from '@edna/components/styles';

export const SmallLabel = styled(Label)`
  ${mixins.f2};
`;
